// extracted by mini-css-extract-plugin
module.exports = {"editingEnabled":"RichTextDisplay_editingEnabled__YNEtP"};